import React, { useCallback, useContext } from 'react';

import { useStoreData } from '../../../../hooks';
import { ApiContext } from '../../../../providers';
import { classNames } from '../../../../services/classNames';
import { parseHTML } from '../../../../services/parseHTML';

export const saveMiddlestep = (middlestepName: any, value: any) =>
    sessionStorage.setItem(
        `middlestep_${String(middlestepName).toLowerCase()}`,
        value,
    );

export const getMiddlestep = (middlestepName: any) =>
    sessionStorage.getItem(
        `middlestep_${String(middlestepName).toLowerCase()}`,
    );

interface BankOfferMiddlestepProps {
    setMiddlestep: any;
    middlestepName: string;
}

export const BankOfferMiddlestep = ({
    setMiddlestep,
    middlestepName,
}: BankOfferMiddlestepProps) => {
    const { Upscore, getRequestID } = useContext(ApiContext);

    const middlesteps = useStoreData().storyblok.MiddlestepItems.items;

    const handleChoice = useCallback(
        async (
            /** @type {"primary_offers"|"secondary_offers"} */ paymentRemarkChoice,
            middlestepName,
        ) => {
            if (!middlestepName) {
                return null;
            }

            const requestID = (await getRequestID()) || '';
            saveMiddlestep(middlestepName, paymentRemarkChoice);
            setMiddlestep(paymentRemarkChoice);

            return Upscore.postUserPaymentRemark({
                requestID,
                paymentRemark: paymentRemarkChoice === 'primary_offers' ? 1 : 0,
            })
                .then((response: any) => response.result)
                .catch((error: any) => console.error(error));
        },
        [middlestepName, setMiddlestep],
    );

    if (!middlesteps || !middlestepName) {
        return null;
    }

    const {
        text,
        primary_offers_button_label: primaryOffersButtonLabel,
        secondary_offers_button_label: secondaryOffersButtonLabel,
    } = middlesteps.find((m: any) => m.slug === middlestepName)?.content || {};

    return text && primaryOffersButtonLabel && secondaryOffersButtonLabel ? (
        <div
            className={classNames(
                'FactorOfferPopup',
                'FactorOfferPopup--popup',
                `FactorOfferPopup--bank_offer`,
            )}
        >
            <div className="FactorOfferPopup__choose">
                <div>{parseHTML(text, 'markdown')}</div>
                <div className="FactorOfferPopup__buttons">
                    <div
                        className="Button Button--primary"
                        onClick={() =>
                            handleChoice('primary_offers', middlestepName)
                        }
                        data-event="bank_offer choice (yes)"
                    >
                        {primaryOffersButtonLabel}
                    </div>
                    <div
                        className="Button Button--primary"
                        onClick={() =>
                            handleChoice('secondary_offers', middlestepName)
                        }
                        data-event="bank_offer choice (no)"
                    >
                        {secondaryOffersButtonLabel}
                    </div>
                </div>
            </div>
        </div>
    ) : null;
};
